var map = {
	"./ar.json": "./src/js/languages/ar.json",
	"./de.json": "./src/js/languages/de.json",
	"./el.json": "./src/js/languages/el.json",
	"./empty.json": "./src/js/languages/empty.json",
	"./es.json": "./src/js/languages/es.json",
	"./fr.json": "./src/js/languages/fr.json",
	"./it.json": "./src/js/languages/it.json",
	"./ja.json": "./src/js/languages/ja.json",
	"./ko.json": "./src/js/languages/ko.json",
	"./lt.json": "./src/js/languages/lt.json",
	"./nl.json": "./src/js/languages/nl.json",
	"./pt.json": "./src/js/languages/pt.json",
	"./ru.json": "./src/js/languages/ru.json",
	"./tr.json": "./src/js/languages/tr.json",
	"./uk.json": "./src/js/languages/uk.json",
	"./zh.json": "./src/js/languages/zh.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/languages sync recursive \\.json$";